/** Тело PATCH questions/{question}: только изменяемые поля */
export class ChangeQuestionParams {
  // declare: поле без значения не попадает в объект и в тело запроса
  declare weight?: number
  declare data?: string

  constructor({ weight, data }: { weight?: number, data?: string }) {
    if (weight !== undefined) {
      this.weight = weight
    }
    if (data !== undefined) {
      this.data = data
    }
  }
}
